import { SVGProps } from "react";

export default function CheckCircleBadgeIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 56, width = 56, ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#AEDDC2" />
      <rect
        x="4"
        y="4"
        width="48"
        height="48"
        rx="24"
        stroke="#DAF0E3"
        strokeWidth="8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.6823 29.6828C36.8221 29.0785 37.5984 27.8799 37.5984 26.5C37.5984 25.1201 36.8221 23.9215 35.6823 23.3173C36.061 22.0841 35.7624 20.6875 34.7867 19.7118C33.8109 18.736 32.4144 18.4375 31.1812 18.8162C30.5769 17.6764 29.3783 16.9 27.9984 16.9C26.6185 16.9 25.4199 17.6764 24.8157 18.8162C23.5825 18.4375 22.186 18.7361 21.2102 19.7118C20.2345 20.6876 19.9359 22.0841 20.3146 23.3173C19.1748 23.9215 18.3984 25.1201 18.3984 26.5C18.3984 27.8799 19.1748 29.0785 20.3146 29.6828C19.9359 30.916 20.2345 32.3125 21.2102 33.2883C22.186 34.264 23.5825 34.5626 24.8157 34.1839C25.42 35.3236 26.6185 36.1 27.9984 36.1C29.3784 36.1 30.5769 35.3236 31.1812 34.1838C32.4144 34.5625 33.8109 34.264 34.7867 33.2882C35.7624 32.3125 36.0609 30.916 35.6823 29.6828ZM32.6263 24.3294C32.9187 23.9274 32.8298 23.3645 32.4278 23.0722C32.0258 22.7798 31.4629 22.8687 31.1706 23.2707L26.9901 29.0189L24.7348 26.7636C24.3834 26.4122 23.8135 26.4122 23.462 26.7636C23.1106 27.1151 23.1106 27.6849 23.462 28.0364L26.462 31.0364C26.6482 31.2225 26.9064 31.3179 27.1688 31.2973C27.4312 31.2767 27.6715 31.1423 27.8263 30.9294L32.6263 24.3294Z"
        fill="#1C472F"
      />
    </svg>
  );
}
